import { useRouter } from 'next/router';
import toast from 'react-hot-toast';

import { getToastErrorMessages, isTokenExpiredError } from './useToast.helpers';
import { IHandleToastErrorParams, IHandleToastSuccessParams, IUseToast } from './useToast.interfaces';

const useToast = (): IUseToast => {
  const { push } = useRouter();

  const handleToastError = ({ error, shouldUseFriendlyErrorMessage = false }: IHandleToastErrorParams) => {
    if (isTokenExpiredError(error)) {
      push('/login');
      return;
    }

    getToastErrorMessages({
      error,
      shouldUseFriendlyErrorMessage,
    }).forEach((errorMessage) => toast.error(errorMessage));
  };

  const handleToastSuccess = ({ message }: IHandleToastSuccessParams) => {
    toast.success(message);
  };

  return {
    handleToastError,
    handleToastSuccess,
  };
};

export { useToast };
